import { createContext, ReactNode, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useAssignmentDetailsQuery } from '../query';
import { AssignmentDetailsContextState } from '../types';

export const AssignmentDetailsContext = createContext<
  AssignmentDetailsContextState | undefined
>(undefined);

export const AssignmentDetailsContextProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const { assignmentId } = useParams();
  const { data, isLoading, isError, error } =
    useAssignmentDetailsQuery(assignmentId);

  const contextValue = useMemo(
    () => ({
      assignmentDetails: data?.data,
      isError,
      error,
      isLoading
    }),
    [data, error, isError, isLoading]
  );

  return (
    <AssignmentDetailsContext.Provider value={contextValue}>
      {children}
    </AssignmentDetailsContext.Provider>
  );
};
